// extracted by mini-css-extract-plugin
export var center = "_5e-2";
export var clickableRow = "_5e-5";
export var expandedRow = "_5e-7";
export var hoverable = "_5e-4";
export var left = "_5e-1";
export var right = "_5e-3";
export var row = "_5e-0";
export var selectedRow = "_5e-6";
export var summaryRow = "_5e-8";